module.exports = __webpack_public_path__ + "img/Katrina Mei.d35bb420.jpg";